import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@features/auth/slice';

export function useIsAuthenticated(): boolean {
  return useSelector(selectIsAuthenticated);
}
